import { Component, Injector, OnInit, inject } from '@angular/core';
import { StkmfService, templateUrlConfigStk } from './../_service_stk';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { StkmfEditComponent, } from './../_edit_stk';
import { PageKind, UiModeType, } from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';



@Component({
  selector: 'app-stkpi13-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigStk.stkpi13_detail,
  styleUrls: [],
})
export class Stkpi13DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi13-detail';
  constructor() {
    super();
    this.srv = new StkmfService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'MF001=ME001';
    this.masterEditPage = StkmfEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'MF002', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };

    this.constructorInit(); // ###

  }



}
